export default "__VITE_ASSET__DFQGpW1q__"